import { storeToRefs } from 'pinia';
import mainStore from '@/stores/main-store';

const useMainStore = () => {
    const { setAccessToken, setUsername, setPrivileges, setPrivilegesFailure } = mainStore();

    const { accessToken, username, oid, claims, privileges, privilegesFailed, userRoles } = storeToRefs(mainStore());

    return {
        accessToken,
        username,
        setAccessToken,
        setUsername,
        userRoles,
        oid,
        claims,
        setPrivileges,
        setPrivilegesFailure,
        privileges,
        privilegesFailed
    };
};

export default useMainStore;
